module.exports = function(service) {
	'use strict'
	service.service('downloadImage',downloadImage);
	downloadImage.$inject=[];
	function downloadImage() {
		return function(imgObj) {
            if(!imgObj || !imgObj.file) return
            var match = imgObj.file.match(/[^/]+$/);
            var fileName = match[0];
            if(!fileName) return
            fetch(imgObj.file)
            .then(function(response){ return response.blob()})
            .then(function(imageBlob) {
                var imageURL = URL.createObjectURL(imageBlob);
                var link = document.createElement('a');
                link.href = imageURL;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                // Revoke the object URL to free up memory
                URL.revokeObjectURL(imageURL);
            })
            .catch(function(error){
                console.error('Error fetching or processing the image:', error);
            });
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/downloadImageService.js
// module id = 596
// module chunks = 0